import { FC }  from "react";
import { useNavigate } from 'react-router-dom';
import { Button } from "@mui/material";
import { useQueryClient } from 'react-query';

import { DataTable } from "./DataTable";

import { LogoBlue }    from "../../shared/components/Logo";
import { EAuthRoutes } from "../../shared/constants/constants";

import { ReactComponent as ImageGroup } from '../../../images/family-group.svg';

import {
  AuthSVGSceneHolder,
  PageHeader,
  SignUpContainer,
} from "../shared/styles";

import {
  BlockName,
  BlockPrice,
  BlockWrapper,
  EmptyBlockWrapper,
  FreeBlockName,
  FreeBlockWrapper,
  InfoBlockName,
  InfoBlockWrapper,
  Wrapper,
} from "./styles";

export const ChangeSubscription: FC = () => {
  const history = useNavigate();
  const queryClient = useQueryClient();

  const createSubscription = (link: string) => {
    history({ pathname: link });
  };

  return (
    <SignUpContainer maxWidth="md">
      <PageHeader mb="20px">
        <LogoBlue />
      </PageHeader>

      <Wrapper container sm={12} md={12} lg={12} spacing={3}>
        <>
          <FreeBlockWrapper item sm={12} md={3} lg={3}>
            <FreeBlockName>Free Plan</FreeBlockName>
            <EmptyBlockWrapper />

            <Button
              fullWidth
              type="submit"
              size="medium"
              color="primary"
              variant="contained"
              onClick={() => {
                queryClient.setQueryData('SubscriptionPlan', 'Free');
                createSubscription(EAuthRoutes.CreateFamily);
              }}
            >
              Select
            </Button>
          </FreeBlockWrapper>

          <BlockWrapper item sm={12} md={3} lg={3}>
            <BlockName>Premium Plan</BlockName>
            <BlockPrice>$9.99 / month</BlockPrice>
            <BlockPrice>4-week Free Trial</BlockPrice>

            <Button
              fullWidth
              type="submit"
              size="medium"
              color="primary"
              variant="contained"
              onClick={() => createSubscription(EAuthRoutes.Checkout)}
            >
              Select
            </Button>
          </BlockWrapper>
        </>

        <InfoBlockWrapper
          item
          sm={5}
          md={5}
          lg={5}
          sx={{ display: { xs: 'none', md: 'flex' } }}
        >
          <AuthSVGSceneHolder>
            <ImageGroup />
          </AuthSVGSceneHolder>
        </InfoBlockWrapper>
      </Wrapper>
      <>
        <InfoBlockName>What do you get?</InfoBlockName>

        <DataTable />
      </>
    </SignUpContainer>
  );
};
